import { IListUserVolSurfacesBySymbol } from '../../../providers/otc-trader/types';

type RowData = {
  tenor: string;
  [key: string]: string;
};

export const deltaParameters: { [key: string]: string[] } = {
  delta_1: ['ATMF', '25C', '25P', '10C', '10P'],
  delta_2: ['ATMF', '25RR', '25FLY', '10RR', '10FLY'],
  delta_3: ['ATMF', '25RR', '25FLY', '10/25RR', '10/25FLY'],
};

export const getDeltaFromSurface = (surface: IListUserVolSurfacesBySymbol): string | undefined => {
  const vols = surface.vols;

  let delta: string | undefined = undefined;

  vols.forEach((vol) => {
    Object.entries(deltaParameters).forEach(([key, arrItems]) => {
      if (arrItems.includes(vol.tag)) {
        delta = key;
      }
    });
  });

  if (delta) {
    return `${delta}`.toLowerCase();
  }

  return undefined;
};

export const getDeltaFromKey = (tag: string): string | undefined => {
  for (const [delta, tags] of Object.entries(deltaParameters)) {
    if (tags.includes(tag)) {
      return delta;
    }
  }
  return undefined;
};

export const getDeltaFromKeys = (keys: string[]): string | undefined => {
  if (keys.includes('10C')) return 'delta_1';
  if (keys.includes('10RR')) return 'delta_2';
  if (keys.includes('10/25RR')) return 'delta_3';

  return undefined;
};

export const transformData = (volatilityTableData: RowData[], delta: string) => {
  if (!deltaParameters.hasOwnProperty(delta)) {
    return null;
  }

  const param = deltaParameters[delta as any];

  const result = volatilityTableData.reduce((acc: Record<string, any>, row: RowData) => {
    const tenor = row.tenor;

    acc[tenor] = param.reduce((paramAcc: Record<string, any>, param: string) => {
      if (param in row) {
        paramAcc[param] = row[param as keyof RowData];
      }
      return paramAcc;
    }, {});

    return acc;
  }, {});

  return result;
};
